





























































import Vue from 'vue';
import InfiniteLoading from 'vue-infinite-loading';
import { VBTooltip } from 'bootstrap-vue';
import { isBoolean } from 'lodash';

import ZenMultiselect from '@reciprocity/multiselect';
import { DropdownOption } from '@/components/cards/types';
import { getTooltipOptions, getPersonFullLabel } from '@/components/tooltips/utils';
import { getRequest } from '../../utils/client/client';

export default Vue.extend({
  name: 'DropdownPresenter',
  components: {
    ZenMultiselect,
    InfiniteLoading,
  },
  directives: {
    BTooltip: VBTooltip,
  },
  props: {
    options: {
      type: [Array as () => DropdownOption[] | String],
      default: () => [],
    },
    selectedOption: {
      type: [Object, Array],
      default: undefined,
    },
    optionsUrl: {
      type: String,
      default: undefined,
    },
    placeholder: {
      type: String,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: 'dropdown',
    },
    required: {
      type: Boolean,
      default: false,
    },
    taggable: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [Array as () => DropdownOption[] | String, Object as () => DropdownOption, String],
      default: undefined,
    },
    trackBy: {
      type: String,
      default: 'value',
    },
    label: {
      type: String,
      default: 'label',
    },
    allowEmpty: {
      type: Boolean,
      default: null,
    },
  },
  data() {
    let preselected = [];
    if (this.options.length) {
      preselected = this.options.filter(op => op.selected);
    } else if (this.selectedOption) {
      preselected = this.selectedOption;
    }

    return {
      internalValue: <string | string[] | DropdownOption[]>preselected,
      allOptions: <DropdownOption[]>this.options,
      newTags: <DropdownOption[]>[],
      page: <number>1,
      hasMore: <boolean>Boolean(this.optionsUrl),
      query: <string>'',
    };
  },
  computed: {
    computedOptions(): DropdownOption[] {
      return this.newTags.concat(this.allOptions);
    },
    isPersonDropdown(): boolean {
      return !!this.allOptions.find(o => !!o.role);
    },
    insideSPA(): boolean {
      return !!this.$router;
    },
    isEmptyAllowed(): boolean {
      return isBoolean(this.allowEmpty) ? this.allowEmpty : !this.required;
    },
  },
  watch: {
    value: {
      handler(newVal: DropdownOption[]) {
        // Skip if default prop value
        if (!this.selectedOption && newVal != undefined) {
          this.internalValue = newVal;
        }
      },
      immediate: true,
    },
    options(newOptions: DropdownOption[]) {
      this.allOptions = newOptions;
    },
  },
  created() {
    if (this.optionsUrl) {
      this.fetchOptions();
    }
  },
  methods: {
    async fetchOptions(clearOptions = false) {
      try {
        const data = await getRequest({
          url: this.optionsUrl,
          params: {
            page: this.page,
            query: this.query,
          },
        });

        if (clearOptions) {
          this.allOptions = [];
        }

        this.allOptions = this.allOptions.concat(this.mapDropdownValues(data.options));

        this.hasMore = data.more;
        this.page++;
      } catch (e) {
        const alert = {
          type: 'warning',
          message: 'Something went wrong while fetching options.',
        };
        if (this.insideSPA) {
          this.$store.dispatch('alerts/show', alert);
        } else {
          window.GGRC.Notify();
        }
      }

      return Promise.resolve();
    },
    // TODO: Temporary, will be removed when dropdowns are consolidated into a
    //       single component.
    mapDropdownValues(options: DropdownOption[]): DropdownOption[] {
      options.forEach((option: DropdownOption) => {
        if ('disabled' in option) {
          option['$isDisabled'] = option['disabled'];
          delete option['disabled'];
        }
      });

      return options;
    },
    async infiniteHandler($state: any) {
      await this.fetchOptions();
      $state.loaded();
      if (!this.hasMoreRest) {
        $state.complete();
      }
    },
    searchHandler(query: string) {
      if (this.optionsUrl) {
        this.page = 1;
        this.query = query;
        // Always fetches fresh data from server when searching
        this.fetchOptions(true);
      }
    },
    addTag(newTag: string) {
      this.newTags.push({ value: newTag, label: newTag });
      if (Array.isArray(this.value)) {
        this.value.push({ value: newTag, label: newTag });
      }
    },
    getTooltipOptions,
    getPersonFullLabel,
  },
});
